export let ExceptionType = /*#__PURE__*/function (ExceptionType) {
  ExceptionType["HANDLED"] = "HANDLED";
  ExceptionType["UNHANDLED"] = "UNHANDLED";
  return ExceptionType;
}({});
export let StacktraceScriptType = /*#__PURE__*/function (StacktraceScriptType) {
  StacktraceScriptType["WIX_SERVICE"] = "WIX_SERVICE";
  StacktraceScriptType["WIX_APP"] = "WIX_APP";
  StacktraceScriptType["WIX_CHAT"] = "WIX_CHAT_WIDGET";
  StacktraceScriptType["BROWSER_EXTENSION"] = "BROWSER_EXTENSION";
  return StacktraceScriptType;
}({});
//# sourceMappingURL=types.js.map